import { assetActionService } from 'api/assetActionService';
import { assetEditService } from 'api/assetEditService';
import { BASE_URL, HOME_PAGE } from 'constants/routes';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

interface ActionsProps {
  action: string;
  inputProps: any; // Adjust type as needed
  handleActionResponse?: (response: any,action:string,inputProps:any) => void;
}

const Actions: React.FC<ActionsProps> = ({ action, inputProps, handleActionResponse }) => {

  const {userName} = useSelector((state:any) => state.userTypeReducer?.userType?.data) || {};
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const navigate = useNavigate();
  const {asset_id}= inputProps || {};
  const publishOrUnpublish =async ({operation}: {operation: string}) => {
    const id = asset_id || inputProps?.assetId;
    try {
      dispatch({ type: 'LOADING SUCCESS', payload: true });
      const response = await assetActionService.assetPublishOrUnpublish(id, operation, userName);
      dispatch({ type: 'LOADING SUCCESS', payload: false });
      handleActionResponse?.(response,action, inputProps);
    }
    catch (error) {
      dispatch({ type: 'LOADING SUCCESS', payload: false });
      handleActionResponse?.(error,action, inputProps);
      console.error(`Error during asset ${action}:`, error);
    }
  };

  const assetDownload = async (path: string, fileName: string) => {
    try {
      dispatch({ type: 'LOADING SUCCESS', payload: true });
      const response = await assetEditService.getPresignedUrl(path);
      dispatch({ type: 'LOADING SUCCESS', payload: false });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      const fileResponse = await fetch(data.success.preSignedURL);
      if (!fileResponse.ok) {
        throw new Error('Failed to fetch the file');
      }
      const blob = await fileResponse.blob();

      // Create a temporary link element to trigger the download
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.href = url;

      // Set the download attribute to specify the file name
      link.download = fileName;

      link.click();

      // Revoke the object URL to free up memory
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error fetching presigned URL:', error);
    }
  };

  useEffect(() => {
    const id = inputProps?.asset_id || inputProps?.assetId;
    if(action==='view') {
      handleActionResponse?.(null,action, inputProps);
      navigate(`${BASE_URL}/asset-detail/${id}`,{
        state: { from: inputProps?.navigateBackTo || HOME_PAGE } // Pass the from context
        
      });
    }
    else if(action==='edit'){
      handleActionResponse?.(null,action, inputProps);
      navigate(`${BASE_URL}/asset-edit/${id}`,{
        state: { from: inputProps?.navigateBackTo || HOME_PAGE }
      });
    }
    else if(action==='checkIn') {
      handleActionResponse?.(null,action, inputProps);
      navigate(`${BASE_URL}/asset-check-in/${id}`);
    }
    else if(action==='publish') {
      publishOrUnpublish({operation: 'PUBLISH' });
    }
    else if(action==='unpublish') {
      publishOrUnpublish({operation: 'UNPUBLISH' });
    }
    else if (action === 'download') {
      const path = inputProps['TFS.FIELD.ORIG_FILE_PATH'];
      const name = inputProps['ARTESIA.FIELD.ASSET NAME'];

      assetDownload(path, name);
    }

  }, [action]);

  // Explicitly return null since this component does not render anything
  return null;
};

export default Actions;